import { createFileRoute } from '@tanstack/react-router';
import { CommunicationsListPage } from '~/pages/admin/communications-list-page';

// Search params validation
const communicationsSearchSchema = {
  org: String,
  userId: String,
  topicId: String,
  status: String,
  cursor: String,
};

export const Route = createFileRoute('/admin/communications/')({
  component: CommunicationsListPage,
  validateSearch: (search) => ({
    org: search.org as string | undefined,
    userId: search.userId as string | undefined,
    topicId: search.topicId as string | undefined,
    status: search.status as "pending" | "processing" | "done" | "failed" | "scheduled" | undefined,
    cursor: search.cursor as string | undefined,
  }),
});

